import getGraphQlClient from '~graphql/getGraphQlClient';
import { CREATE_QUOTE } from '../queries/quotes';

export const createQuote = async (fields) => {
  const graphQlClient = await getGraphQlClient();

  return graphQlClient.mutate({
    mutation: CREATE_QUOTE,
    variables: { fields },
  });
};
